import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface PublicLayoutProps {
  children?: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 mx-4 md:mx-8 lg:mx-16 xl:mx-80">
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
}
